module.exports = __webpack_public_path__ + "media/images/icons/SVG/053-adf5f0eb8fb8106f31832d700fec240f.svg";